const DELIVERY_TZ = "America/New_York";

const SHORT_DATE = new Intl.DateTimeFormat("en-US", {
  timeZone: DELIVERY_TZ,
  month: "short",
  day: "numeric",
});

const WEEKDAY_SHORT_DATE = new Intl.DateTimeFormat("en-US", {
  timeZone: DELIVERY_TZ,
  weekday: "short",
  month: "short",
  day: "numeric",
});

const WEEKDAY_ONLY = new Intl.DateTimeFormat("en-US", {
  timeZone: DELIVERY_TZ,
  weekday: "short",
});

const TIME_SHORT = new Intl.DateTimeFormat("en-US", {
  timeZone: DELIVERY_TZ,
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

export function formatShortDate(d: Date): string {
  return SHORT_DATE.format(d);
}

export function formatWeekdayShort(d: Date): string {
  return WEEKDAY_SHORT_DATE.format(d);
}

export function formatWeekdayOnly(d: Date): string {
  return WEEKDAY_ONLY.format(d);
}

export function formatCutoffLabel(d: Date): string {
  const weekday = WEEKDAY_ONLY.format(d);
  const time = TIME_SHORT.format(d).replace(/\s/g, "").toLowerCase();
  return `${weekday} ${time}`;
}

// Formats a remaining-ms value as "{d}d {h}h {m}m" (minute resolution).
// Negative or zero produces "0d 0h 0m".
export function formatCountdown(remainingMs: number): string {
  const total = Math.max(0, Math.floor(remainingMs / 60000)); // total minutes
  const days = Math.floor(total / (24 * 60));
  const hours = Math.floor((total % (24 * 60)) / 60);
  const minutes = total % 60;
  return `${days}d ${hours}h ${minutes}m`;
}

// Hero-card variant: drops minutes. "Cutoff in 3d 5h for Monday's box."
export function formatCountdownShort(remainingMs: number): string {
  const totalMinutes = Math.max(0, Math.floor(remainingMs / 60000));
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  return `${days}d ${hours}h`;
}

const WEEKDAY_LONG = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
  weekday: "long",
});

export function formatWeekdayLong(d: Date): string {
  return WEEKDAY_LONG.format(d);
}
